import axios from 'axios'
import React from 'react'
import { AuthActionTypes, AuthTypes } from './authReducer'
import { Error } from '../../functions'

interface IAuth {
  error: string
  token: string
  expireAt: number
}

type Auth = IAuth

export const authLogin = async (dispatch: React.Dispatch<AuthActionTypes>, rootUrl: string, jsonData: string, callbackSuccessful: () => void, callbackError: (error?: string) => void): Promise<void> => {
  dispatch({ type: AuthTypes.AUTH_REQUEST })

  try {
    const response = await axios.post('api/auth/login', jsonData, {
      withCredentials: false,
      baseURL: rootUrl,
      headers: { 'Content-Type': 'application/json' }
    })

    if (!!response && !!response.data) {
      const auth = response.data as Auth
      if (auth.token) {
        const expireDate = new Date(auth.expireAt * 1000)

        localStorage.setItem('tokenSession', auth.token)
        localStorage.setItem('expireDate', String(expireDate))

        dispatch({ type: AuthTypes.AUTH_SUCCESS, authToken: String(auth.token) })
        autoRefresh(dispatch, rootUrl, expireDate.getTime() - new Date().getTime())

        if (callbackSuccessful) {
          callbackSuccessful()
        }
      } else {
        const authError = 'Что то пошло не так, попробуйте войти чуть позже'
        dispatch({
          type: AuthTypes.AUTH_ERROR,
          authError
        })
        if (callbackError) {
          callbackError(authError)
        }
      }
    } else {
      const authError = 'Что то пошло не так, попробуйте войти чуть позже'
      dispatch({
        type: AuthTypes.AUTH_ERROR,
        authError
      })
      if (callbackError) {
        callbackError(authError)
      }
    }
  } catch (e) {
    const error = e as Error
    let authError = ''
    if (error.request.status === 401) {
      authError = 'Неверный логин или пароль'
      dispatch({ type: AuthTypes.AUTH_ERROR, authError })
    } else {
      authError = 'Что то пошло не так, попробуйте войти чуть позже'
      dispatch({
        type: AuthTypes.AUTH_ERROR,
        authError
      })
    }
    if (callbackError) {
      callbackError(authError)
    }
  }
}

export const autoRefresh = (dispatch: React.Dispatch<AuthActionTypes>, rootUrl: string, time: number): void => {
  setTimeout(() => {
    void authRefresh(dispatch, rootUrl).then()
  }, time - (Math.floor(Math.random() * 59) + 1) * 60 * 1000)
}

export const authLogout = (dispatch: React.Dispatch<AuthActionTypes>, callback: () => void): void => {
  localStorage.clear()

  dispatch({ type: AuthTypes.AUTH_LOGOUT })

  if (callback) callback()
}

export const authRefresh = async (dispatch: React.Dispatch<AuthActionTypes>, rootUrl: string): Promise<void> => {
  const token = localStorage.getItem('tokenSession')

  if (!token) {
    authLogout(dispatch, null)
  } else {
    let expireDate = new Date(localStorage.getItem('expireDate'))

    if (expireDate < new Date()) {
      authLogout(dispatch, null)
    } else {
      try {
        const response = await axios.get('api/auth/refresh/token', {
          withCredentials: false,
          baseURL: rootUrl,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('tokenSession')
          }
        })

        const auth = response.data as Auth

        if (auth.error) {
          authLogout(dispatch, null)
        } else {
          if (auth.token) {
            expireDate = new Date(auth.expireAt * 1000)

            localStorage.setItem('tokenSession', auth.token)
            localStorage.setItem('expireDate', String(expireDate))

            dispatch({ type: AuthTypes.AUTH_SUCCESS, authToken: auth.token })
            autoRefresh(dispatch, rootUrl, expireDate.getTime() - new Date().getTime())
          } else {
            dispatch({ type: AuthTypes.AUTH_SUCCESS, authToken: token })
            autoRefresh(dispatch, rootUrl, expireDate.getTime() - new Date().getTime())
          }
        }
      } catch (e) {
        const error = e as Error
        if (error.request.status === 401 || error.request.status === 422) {
          authLogout(dispatch, null)
        } else {
          dispatch({ type: AuthTypes.AUTH_SUCCESS, authToken: token })
          autoRefresh(dispatch, rootUrl, expireDate.getTime() - new Date().getTime())
        }
      }
    }
  }
}
